import React, { useState } from "react";
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Input,
    Heading,
    Text,
    useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { API_BASE_URL } from "../config/adminConfig";

function LoginPage() {
    const { login } = useContext(AuthContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const toast = useToast();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/auth/local-login`,
                { email, password }
            );

            // Save token in context
            login(response.data.token);

            toast({
                title: "Login Successful",
                description: "Welcome back to FinanSee B2C Admin Dashboard!",
                status: "success",
                duration: 4000,
                isClosable: true,
                position: "top",
            });

            navigate("/"); // redirect to dashboard
        } catch (err) {
            toast({
                title: "Login Failed",
                description:
                    err.response?.data?.message || "Something went wrong. Try again.",
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Flex
            align="center"
            justify="center"
            minH="100vh"
            bg="#f5f7fa"
            px={4}
        >
            <Box
                bg="white"
                p={8}
                rounded="2xl"
                shadow="lg"
                w="full"
                maxW="md"
            >
                <Heading
                    as="h2"
                    size="lg"
                    mb={6}
                    textAlign="center"
                    color="#000"
                >
                    FinanSee B2C Admin Login
                </Heading>

                <form onSubmit={handleSubmit}>
                    <FormControl id="email" mb={4} isRequired>
                        <FormLabel>Email address</FormLabel>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                        />
                    </FormControl>

                    <FormControl id="password" mb={6} isRequired>
                        <FormLabel>Password</FormLabel>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                        />
                    </FormControl>

                    <Button
                        type="submit"
                        colorScheme="blue"
                        bg="#007AFF"
                        size="lg"
                        w="full"
                        isLoading={loading}
                        loadingText="Logging in"
                        _hover={{ bg: "#005FCC" }}
                    >
                        Login
                    </Button>
                </form>

                <Text textAlign="center" mt={4} fontSize="sm" color="gray.500">
                    Welcome to FinanSee Admin Dashboard
                </Text>
            </Box>
        </Flex>
    );
}

export default LoginPage;
